<template>
  <div class="air-breathing-apparatus">
    <!-- Hero Section -->
    <section class="hero-section" :style="{backgroundImage: `url(${require('@/assets/bg1.png')})`}">
      <div class="hero-overlay"></div>
      <div class="container">
        <div class="hero-content">
          <div class="content-left">
            <h1 class="hero-title">空气呼吸器检测</h1>
            <p class="hero-subtitle">专业检测服务，确保呼吸防护设备在关键时刻可靠运行</p>
            <p class="hero-description">
              我们严格按照国家标准和行业规范，为您提供全面的空气呼吸器检测服务，包<br />
              括气密性测试、压力测试、报警功能检测等，确保每一台设备都符合安全要<br />
              求。
            </p>
            <button class="btn-primary">立即预约检测</button>
          </div>
          <div class="content-right">
            <div class="hero-image">
              <img src="@/assets/air-breathing/image-1.png" alt="空气呼吸器检测设备" />
              <div class="badge">
                <img src="@/assets/air-breathing/image-4.png" alt="图标" class="badge-icon" />
                <span>国家级检测资质</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 检测流程 Section -->
    <section class="process-section">
      <div class="container">
        <h2 class="section-title">检测流程</h2>
        <div class="process-grid">
          <div class="process-card">
            <div class="process-number">1</div>
            <h3 class="process-title">接受检验任务</h3>
            <p class="process-desc">受理委托，核对仪器信息及检验要求</p>
          </div>
          <div class="process-card">
            <div class="process-number">2</div>
            <h3 class="process-title">检验前准备</h3>
            <p class="process-desc">准备检验设备、工具及相关检测仪器</p>
          </div>
          <div class="process-card">
            <div class="process-number">3</div>
            <h3 class="process-title">上机检测</h3>
            <p class="process-desc">进行气密性、压力、报警等关键功能测试</p>
          </div>
          <div class="process-card">
            <div class="process-number">4</div>
            <h3 class="process-title">出具检验报告</h3>
            <p class="process-desc">生成检验证书，提供使用建议和维护方案</p>
          </div>
        </div>
      </div>
    </section>

    <!-- 检测标准 Section -->
    <section class="standard-section">
      <div class="container">
        <h2 class="section-title">检测标准</h2>
        <div class="standard-content-new">
          <div class="standard-card-full">
            <div class="standard-header">
              <i class="el-icon-document"></i>
              <h3>检验依据</h3>
            </div>
            <div class="standard-body">
              <ul class="standard-list-new">
                <li>XF 124-2013《正压式空气呼吸器》</li>
                <li>GB/T 16556-2007《自给开路式压缩空气呼吸器》</li>
                <li>AQ/T 6110-2012《工业空气呼吸器安全使用维护管理规范》</li>
                <li>GB6220-2009《呼吸防护长管呼吸器》</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'AirBreathingApparatus',
  methods: {
    // 后续可以添加预约检测等方法
  }
}
</script>

<style scoped>
/* 基础容器 */
.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

/* Hero Section */
.hero-section {
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  color: white;
  height: 470px;
  position: relative;
  overflow: hidden;
  display: flex;
  align-items: center;
}

.hero-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(to right, rgba(30, 58, 138, 0.75) 0%, rgba(59, 130, 246, 0.45) 50%, rgba(255, 255, 255, 0.20) 100%);
  z-index: 1;
}

.hero-section > .container {
  position: relative;
  z-index: 2;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
}

.hero-content {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 60px;
}

.content-left {
  flex: 1;
  max-width: 520px;
}

.content-right {
  flex: 1;
  display: none;
  justify-content: center;
  align-items: flex-start;
}

.hero-image {
  position: relative;
  width: 380px;
  height: 300px;
}

.hero-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 8px;
  box-shadow: 0px 20px 40px -12px rgba(0, 0, 0, 0.2);
}

.badge {
  position: absolute;
  bottom: -12px;
  right: -12px;
  display: flex;
  align-items: center;
  gap: 6px;
  background: white;
  padding: 6px 14px;
  border-radius: 6px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.badge-icon {
  width: 14px !important;
  height: 14px !important;
  object-fit: contain;
}

.badge span {
  font-size: 14px;
  font-weight: 700;
  color: #111827;
}

.hero-title {
  font-size: 32px;
  font-weight: 700;
  margin-bottom: 16px;
  line-height: 38px;
  color: #ffffff;
  text-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
}

.hero-subtitle {
  font-size: 18px;
  font-weight: 400;
  margin-bottom: 16px;
  line-height: 26px;
  color: #e0f2fe;
  text-shadow: 0 1px 4px rgba(0, 0, 0, 0.2);
}

.hero-description {
  font-size: 15px;
  line-height: 22px;
  margin-bottom: 24px;
  color: #f0f9ff;
  text-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
}

.btn-primary {
  background: linear-gradient(90deg, #1e3a8a 0%, #3b82f6 100%);
  color: white;
  border: none;
  padding: 10px 24px;
  font-size: 15px;
  font-weight: 600;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.btn-primary:hover {
  background: linear-gradient(90deg, #1e40af 0%, #60a5fa 100%);
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(30, 58, 138, 0.3);
}

/* 检测流程 Section */
.process-section {
  padding: 40px 0;
  background: #f8f9fa;
}

.section-title {
  font-size: 36px;
  font-weight: bold;
  text-align: center;
  margin-bottom: 30px;
  color: #2c3e50;
}

.process-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 20px;
}

.process-card {
  background: white;
  padding: 28px 24px;
  border-radius: 12px;
  text-align: center;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
  transition: all 0.3s ease;
}

.process-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
}

.process-number {
  width: 50px;
  height: 50px;
  background: linear-gradient(135deg, #1e3a8a 0%, #3b82f6 100%);
  color: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  font-weight: bold;
  margin: 0 auto 20px;
}

.process-title {
  font-size: 20px;
  font-weight: 600;
  margin-bottom: 12px;
  color: #2c3e50;
}

.process-desc {
  font-size: 15px;
  color: #606266;
  line-height: 1.6;
}

/* 检测标准 Section */
.standard-section {
  padding: 40px 0;
  background: white;
}

.standard-content-new {
  max-width: 900px;
  margin: 0 auto;
}

.standard-card-full {
  background: #f8f9fa;
  border-radius: 12px;
  padding: 24px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
  transition: all 0.3s ease;
}

.standard-card-full:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
}

.standard-header {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 16px;
  padding-bottom: 12px;
  border-bottom: 2px solid #1e3a8a;
}

.standard-header i {
  font-size: 28px;
  color: #1e3a8a;
}

.standard-header h3 {
  font-size: 22px;
  font-weight: 600;
  color: #2c3e50;
  margin: 0;
}

.standard-body {
  padding: 0;
}

.standard-list-new {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.standard-list-new li {
  font-size: 16px;
  line-height: 1.8;
  color: #1f2937;
  padding-left: 24px;
  position: relative;
}

.standard-list-new li::before {
  content: '•';
  position: absolute;
  left: 8px;
  color: #1e3a8a;
  font-size: 20px;
  font-weight: bold;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .hero-section {
    height: auto;
    min-height: 400px;
    padding: 80px 0 40px;
  }

  .hero-content {
    flex-direction: column;
    gap: 40px;
  }

  .content-left {
    max-width: 100%;
  }

  .content-right {
    width: 100%;
  }

  .hero-image {
    width: 100%;
    max-width: 400px;
    height: auto;
    aspect-ratio: 4/3;
  }

  .hero-title {
    font-size: 28px;
    line-height: 1.3;
    margin-bottom: 16px;
  }

  .hero-subtitle {
    font-size: 16px;
    line-height: 1.5;
    margin-bottom: 16px;
  }

  .hero-description {
    font-size: 14px;
    line-height: 1.6;
    display: none;
  }

  .btn-primary {
    width: 100%;
    padding: 12px 24px;
  }

  .badge {
    bottom: -12px;
    right: -12px;
    padding: 6px 12px;
  }

  .badge span {
    font-size: 14px;
  }

  .badge-icon {
    width: 14px !important;
    height: 14px !important;
  }

  .section-title {
    font-size: 24px;
    margin-bottom: 30px;
  }

  .standard-section {
    padding: 40px 0;
  }

  .standard-content-new {
    padding: 0 10px;
  }

  .standard-card-full {
    padding: 24px;
  }

  .standard-header {
    margin-bottom: 20px;
    padding-bottom: 12px;
  }

  .standard-header i {
    font-size: 24px;
  }

  .standard-header h3 {
    font-size: 18px;
  }

  .standard-list-new {
    gap: 12px;
  }

  .standard-list-new li {
    font-size: 15px;
    line-height: 1.6;
    padding-left: 20px;
  }

  .standard-list-new li::before {
    font-size: 18px;
    left: 6px;
  }

  .process-grid,
  .review-grid,
  .sample-grid {
    grid-template-columns: 1fr;
  }
}
</style>

